export const FAQ_URL = "https://help.redgifs.com/hc/en-us/categories/15075712972433-RedGIFs-FAQ";

export const openFaq = () => window.open(FAQ_URL, "_blank");
